module.exports = __webpack_public_path__ + "img/button.a6259a21.svg";